<template>
    <div class="local-data">
        <div class="filter-criteria">
            <div class="filter-title">
                <span>操作记录</span>
                <span>/</span>
                <span>领取记录</span>
            </div>
            <div class="filter-content">
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">领取时间：</span>
                        <a-range-picker class="date-range" @change="onChange" style="" format="YYYY-MM-DD HH:mm:ss" />
                    </a-col>
                </a-row>
                <a-row class="row-list">
                    <a-col :span="12">
                        <span class="row-title">负责人：</span>
                        <a-select placeholder='请选择负责人' @change="changePerson" class="charge-person">
                            <a-select-option :value="item.value" v-for="(item,index) in selectList" :key='index'>
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="table-data">
            <div class="table-content">
                <div class="btn-operate">
                    <a-button type="primary" @click="changeName"> 修改 </a-button>
                </div>
                <a-table
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    :data-source="tableData"
                    :pagination="false"
                    :scroll="{ x: 'max-content' }"
                    :rowKey="record => record.id"
                >
                    <a-table-column key="name" title="领取记录名称" data-index="name" />
                    <a-table-column key="status" title="状态" data-index="status" />
                    <a-table-column key="operateTime" title="领取时间" data-index="operateTime" />
                    <a-table-column key="receiveCount" title="领取数量" data-index="receiveCount" />
                    <a-table-column key="consumption" title="消耗点数" data-index="consumption" />
                    <a-table-column key="operator" title="操作人" data-index="operator" />
                </a-table>
                <div class="pagination-table">
                    <div style="float:left;color:rgba(80, 80, 80, 1);font-size:14px">总计：{{total}}条</div>
                    <a-pagination
                        style="float:right"
                        show-size-changer
                        :total="total"
                        :show-total="total => `共 ${total} 条     `"
                        v-model="currentPage"
                        @change="pageChange"
                        @showSizeChange="onShowSizeChange"
                    />
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="changeNameModal" title="修改领取记录名称" footer='' width='480px'>
            <div class="edit-modal modal-public">
                <a-divider class="divider1" type="horizontal" />
                <div class="changed-name">修改领取记录名称：</div>
                <a-input v-model.trim="quotaData" placeholder="请输入领取记录名称" />
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelQuota">取消</a-button>
                    <a-button type="primary" @click="sureQuota">确认</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: 'MonthBill',
        data() {
            return {
                startDate: '',
                endDate: '',
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                loading: false,
                currentPerson: '',
                selectList: [],
                selectedRowKeys: [],
                changeNameModal: false,
                quotaData: ''
            }   
        },
        methods: {
            onChange(date, dateString) {
                console.log(date);
                this.startDate = dateString[0]
                this.endDate = dateString[1]
                this.queryBasicData()
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            queryBasicData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/receive/list', 
                        params: {
                            userId: this.currentPerson,
                            operateTimeStart: this.startDate,
                            operateTimeEnd: this.endDate,
                            current: this.currentPage,
                            size: this.pageSize,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                        this.total = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changePerson(value) {
                this.currentPerson = value
                this.queryBasicData()
            },
            querySelectList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user/selectList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.selectList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                if(this.selectedRowKeys.length > 1){
                    this.$message.error('修改选项只能单选')
                    this.selectedRowKeys = []
                }
            },
            changeName() {
                if(this.selectedRowKeys.length == 0){
                    this.$message.error('请先选择需要修改选项！')
                }else{
                    this.changeNameModal = true
                }
            },
            cancelQuota() {
                this.changeNameModal = false
                this.quotaData = ''
                this.selectedRowKeys = []
            },
            sureQuota() {
                this.changeNameModal = false
                this.axios.post('/api/receive/updateName', {
                    id: this.selectedRowKeys[0],
                    name: this.quotaData,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.quotaData = ''
                        this.selectedRowKeys = []
                        this.queryBasicData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        mounted: function() {
            this.querySelectList()
            this.queryBasicData()
        }
    }
</script>

<style scoped lang="less">
    .local-data{
        height: 100%;
        display: flex;
        flex-direction: column;
        .filter-criteria{
            height: 163px;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            margin-top: 1px;
            padding: 15px 24px;
            .filter-title{
                font-size: 14px;
                span:nth-child(1){
                    color: rgba(0, 0, 0, 0.45);
                }
                span:nth-child(2){
                    color: rgba(0, 0, 0, 0.45);
                    margin: 0 6px;
                }
                span:nth-child(3){
                    color: rgba(0, 0, 0, 0.7);
                }
            }
            .filter-content{
                margin-top: 24px;
                .row-list{
                    margin-bottom: 16px;
                    .row-title{
                        display: inline-block;
                        width: 98px;
                    }
                    .charge-person{
                        width: 240px;
                    }
                    .date-range{
                        width: 320px;
                        // margin-left: 24px;
                    }
                    .search-way{
                        width: 240px;
                    }
                }
                .clean-up{
                    float: right;
                    color: rgba(24, 144, 255, 1);
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
        .table-data{
            flex: 1;
            padding: 24px;
            .table-content{
                width: 100%;
                height: 100%;
                background: #fff;
                padding: 24px;
                .table-data{
                    margin-top: 24px;
                }
                .pagination-table{
                    // float: right;
                    padding-top: 24px;
                    width: 100%;
                }
                .btn-operate{
                    text-align: right;
                    margin-bottom: 24px;
                }
            }
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .divider3{
            margin: 0px 0 12px;
        }
        .btn-group{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                margin-right: 16px;
            }
        }
        .btn-group2{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
        .btn-group3{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(24, 144, 255, 1);
                border: 1px solid rgba(24, 144, 255, 1);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }
    .edit-modal{
        padding-bottom: 48px;
        .changed-name{
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
            margin-top: 24px;
        }
        input{
            margin-top: 8px;
        }
    }
</style>